import React from 'react';
import { Crown, Clock, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSubscription } from '@/contexts/SubscriptionContext';

export function TrialBanner({ onUpgrade }) {
  const { subscriptionInfo } = useSubscription();
  
  if (!subscriptionInfo?.is_trial || !subscriptionInfo?.trial_end) {
    return null;
  }

  // Calculate days remaining
  const trialEnd = new Date(subscriptionInfo.trial_end);
  const now = new Date();
  const daysRemaining = Math.max(0, Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24)));
  
  // Color based on urgency
  const isUrgent = daysRemaining <= 3;
  const bgClass = isUrgent 
    ? 'bg-gradient-to-r from-orange-500/20 to-red-500/20 border-orange-500/30'
    : 'bg-gradient-to-r from-violet-500/20 to-fuchsia-500/20 border-violet-500/30';
  const textClass = isUrgent ? 'text-orange-600' : 'text-violet-600';

  return (
    <div 
      className={`rounded-xl border p-3 mb-4 ${bgClass}`}
      data-testid="trial-banner"
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${
            isUrgent ? 'bg-orange-500/20' : 'bg-violet-500/20'
          }`}>
            <Crown className={`w-5 h-5 ${textClass}`} />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <span className="font-semibold text-sm">Elite Trial</span>
              <span className={`text-xs px-2 py-0.5 rounded-full ${
                isUrgent ? 'bg-orange-500/20 text-orange-600' : 'bg-violet-500/20 text-violet-600'
              }`}>
                {daysRemaining} {daysRemaining === 1 ? 'day' : 'days'} left
              </span>
            </div>
            <p className="text-xs text-muted-foreground flex items-center gap-1">
              <Clock className="w-3 h-3" />
              {isUrgent ? 'Upgrade now to keep your features!' : 'Enjoying premium features'}
            </p>
          </div>
        </div>
        <Button 
          size="sm" 
          className={isUrgent 
            ? 'bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600' 
            : 'bg-gradient-to-r from-violet-500 to-fuchsia-500 hover:from-violet-600 hover:to-fuchsia-600'
          }
          onClick={onUpgrade}
        >
          Upgrade
          <ArrowRight className="w-4 h-4 ml-1" />
        </Button>
      </div>
    </div>
  );
}
